import React, {useMemo, useState} from "react"
import Edit from "../../../assets/images/pencil.svg"
import Trash from "../../../assets/images/trash.svg"
import {IconButton, Box, Typography, Popover} from "@mui/material"
import {Banknote, PenLine, Printer, UserRound, X} from "lucide-react"
import {InfoOutline} from "@mui/icons-material"
import {setPxSuffix} from "../../../misc/utils"

export const widgetIconButtonPrototype = [
    {
        key: "icon",
        type: "ICONSELECT",
        label: "Icon",
        size: 6,
        options: {
            tag: "icons",
        },
    },
    {
        key: "action",
        type: "STRING",
        label: "Aktion",
        size: 3,
    },
    {
        key: "infotext",
        type: "STRING",
        label: "Infotext",
        size: 3,
    },
    {
        key: "buttonSize",
        type: "SELECT",
        label: "Größe des Buttons",
        size: 6,
        options: [
            {
                value: "small",
                label: "Small",
            },
            {
                value: "medium",
                label: "Medium",
            },
            {
                value: "large",
                label: "large",
            },
        ],
    },
    {
        key: "iconSize",
        type: "SELECT",
        label: "Größe des Icons",
        size: 6,
        options: [
            {
                value: "small",
                label: "Small",
            },
            {
                value: "medium",
                label: "Medium",
            },
            {
                value: "large",
                label: "large",
            },
        ],
    },
    {
        key: "infoTextFontSize",
        type: "INTEGER",
        label: "Infotext Schriftgröße in px",
        size: 3,
    },
]

const IconLibrary = (iconColor = "#000") => ({
    edit: <Edit color={iconColor} />,
    trash: <Trash color={iconColor} />,
    printer: <Printer color={iconColor} />,
    user: <UserRound color={iconColor} />,
    x: <X color={iconColor} />,
    pencil: <PenLine color={iconColor} />,
    info: <InfoOutline fontSize={"32px"} color={iconColor} />,
    banknote: <Banknote color={iconColor} />,
})

const IconButtonWidget = ({widget, value, payload, triggerAction}) => {
    const {infoTextFontSize} = widget
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget)
        widget.action && triggerAction(widget.action, {payload: payload ?? value})
    }

    const [anchorEl, setAnchorEl] = useState(null)

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = useMemo(() =>Boolean(anchorEl), [anchorEl])

    return (
        <Box
            onClick={event => event.stopPropagation()}
            display="flex"
            flexDirection="column"
            alignItems={widget.align ?? "center"}>
            <IconButton
                onClick={handleClick}
                size={widget?.buttonSize ?? "small"}
                aria-label="test">
                {IconLibrary(widget.iconColor)[widget.icon]}
            </IconButton>
            {widget?.infotext && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                >
                    <Box p={1} maxWidth="300px">
                        <Typography fontSize={infoTextFontSize ? setPxSuffix(infoTextFontSize) : "16px"}>{widget?.infotext}</Typography>
                    </Box>
                </Popover>
            )}
        </Box>
    )
}

export default IconButtonWidget
